import React from 'react';
import './Button.css';

interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'menu' | 'nav' | 'skip';
  isEnabled?: boolean;
  onClick?: () => void;
  className?: string;
}

export const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  isEnabled = true,
  onClick,
  className = '',
}) => {
  const baseClass = `button button-${variant}`;
  const finalClass = `${baseClass} ${!isEnabled ? 'disabled' : ''} ${className}`.trim();

  return (
    <button 
      className={finalClass}
      onClick={onClick}
      disabled={!isEnabled}
    >
      {children}
    </button>
  );
}; 